module.exports = __webpack_public_path__ + "static/media/bg-take-prize-btn.53495975.png";